import { render, staticRenderFns } from "./PayRangeSuggestionCard.vue?vue&type=template&id=070cc5be&scoped=true"
import script from "./PayRangeSuggestionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeSuggestionCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeSuggestionCard.vue?vue&type=style&index=0&id=070cc5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cc5be",
  null
  
)

export default component.exports